import { render, staticRenderFns } from "./InstallPwa.vue?vue&type=template&id=74d942ad"
import script from "./InstallPwa.vue?vue&type=script&lang=js"
export * from "./InstallPwa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports